import { createSlice } from '@reduxjs/toolkit';
import { programService, storageService } from '../services';

const programSlice = createSlice({
    name: 'program',
    initialState: {
        program: storageService.loadProgram(),
        eventName: '',
        inited: false,
    },
    reducers: {
        setProgram(state, action) {
            state.program = action.payload;
        },
        setCurrentEvent(state, action) {
            console.log('setCurrentEvent', action.payload);
            state.eventName = action.payload;
        },
        setInited(state) {
            state.inited = true;
        },
    },
});

export const { setProgram, setCurrentEvent, setInited } = programSlice.actions;
export default programSlice.reducer;

const fetchProgram = () => async (dispatch, getState) => {
    const state = getState();
    const oldProgram = state.program.program;
    const currentEvent = state.program.eventName;
    const isCurrentEvent = !currentEvent;
    const inited = state.program.inited;
    if (!inited || (oldProgram && !isCurrentEvent)) {
        // если не inited, значит не ясно за какой Event еще грузить программу
        // если есть currentEvent (т.е. это не текущий год), то обновлять программу не надо
        return;
    }
    try {
        console.log('fetch program');
        if (isCurrentEvent) {
            const fetchTs = storageService.loadProgramFetchTs();
            if (fetchTs && Date.now() - fetchTs < 1000 * 30) {
                console.log('fetch program not needed');
                return;
            }
            storageService.saveProgramFetchTs(Date.now());
        }
        const program = await programService.getProgram(currentEvent, oldProgram && oldProgram.ts);
        if (isCurrentEvent) {
            storageService.saveProgram(program);
        }
        if (!oldProgram || program.ts > oldProgram.ts) dispatch(setProgram(program));
    } catch (e) {
        console.error(e);
    }
};

let fetchProgramTimer = null;
export const fetchProgramDelayed = () => {
    return (dispatch) => {
        if (fetchProgramTimer) clearTimeout(fetchProgramTimer);
        fetchProgramTimer = setTimeout(() => {
            dispatch(fetchProgram());
            fetchProgramTimer = null;
        }, 10);
    };
};

export const changeCurrentEventAndUpdateProgram = (newEventName) => async (dispatch, getState) => {
    const state = getState();
    const oldEventName = state.program.eventName;
    if (!state.program.inited) dispatch(setInited());
    if (oldEventName !== newEventName) {
        dispatch(setCurrentEvent(newEventName));
        dispatch(setProgram(newEventName ? null : storageService.loadProgram()));
    }
    dispatch(fetchProgramDelayed());
};
